module.exports = __webpack_public_path__ + "img/anquandaka.5b8c3387.png";